import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import HtmlEditor from "./HtmlEditor.vue";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlHtml',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlHtml');
        const model = useFieldModel(() => (typeof props.data === 'string') ? props.data : undefined);
        function onChange(value) {
            model.value = value;
            emitChange(value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(HtmlEditor, {
                "model-value": _unref(model),
                "onUpdate:modelValue": onChange,
                onFocus: _unref(onFocus),
                onBlur: _unref(onBlur),
                id: __props.fieldId,
                disabled: _unref(fieldOptions).disabled ?? undefined,
                placeholder: _unref(fieldOptions).placeholder,
                rows: _unref(fieldOptions).rows,
                class: _normalizeClass(["form__control", 'form__control--' + __props.field.type])
            }, null, 8, ["model-value", "onFocus", "onBlur", "id", "disabled", "placeholder", "rows", "class"]));
        };
    }
});
